import React from 'react';
import { Bed, Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Logo = ({ size = 'normal', showText = true }) => {
  const { t } = useTranslation();
  const sizes = {
    small: { container: 'w-8 h-8', text: 'text-base', icon: 'w-4 h-4' },
    normal: { container: 'w-12 h-12', text: 'text-xl', icon: 'w-6 h-6' },
    large: { container: 'w-16 h-16', text: 'text-2xl', icon: 'w-8 h-8' }
  };

  const s = sizes[size] || sizes.normal;

  return (
    <div className="flex items-center gap-3">
      {/* Logo Icon */}
      <div className={`${s.container} relative flex items-center justify-center`}>
        {/* Background gradient circle */}
        <div className="absolute inset-0 bg-gradient-to-br from-blue-600 via-blue-500 to-purple-600 rounded-2xl shadow-lg shadow-blue-500/50 animate-pulse-slow"></div>
        
        {/* Inner glow */}
        <div className="absolute inset-1 bg-gradient-to-br from-blue-400 to-purple-400 rounded-xl opacity-60 blur-sm"></div>
        
        {/* Icon container */}
        <div className="relative z-10 flex items-center justify-center">
          <Bed className={`${s.icon} text-white drop-shadow-lg`} strokeWidth={2.5} />
        </div>
        
        {/* Sparkle accent */}
        <Sparkles className="absolute -top-1 -right-1 w-3 h-3 text-yellow-400 animate-pulse" />
      </div>

      {/* Logo Text */}
      {showText && (
        <div className="flex flex-col">
          <div className="flex items-baseline gap-1">
            <span className={`${s.text} font-black bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent`}>
              travel
            </span>
            <span className={`${s.text} font-black bg-gradient-to-r from-orange-500 to-red-600 bg-clip-text text-transparent`}>
              discount
            </span>
          </div>
          <span className="text-[10px] text-slate-500 font-medium tracking-tight mt-1 leading-tight">
            {t('logo.claim')}
          </span>
        </div>
      )}
    </div>
  );
};

export default Logo;
